import { render, staticRenderFns } from "./CurrencySwitch.vue?vue&type=template&id=2bb82c94&lang=pug&"
import script from "./CurrencySwitch.vue?vue&type=script&lang=js&"
export * from "./CurrencySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports